import { Directive, HostListener, Inject, Input, DOCUMENT } from '@angular/core'


@Directive({
    selector: '[appClickTriggerFor]',
    standalone: true
})
export class ClickTriggerForDirective {

  @Input() appClickTriggerFor = ''

  private target: HTMLButtonElement | null = null

  @HostListener('click')
  onClick() {
    if (!this.target) {
      this.target = this.document.querySelector<HTMLButtonElement>(this.appClickTriggerFor)
    }

    this.target?.click()
  }

  constructor(@Inject(DOCUMENT) private readonly document: Document) { }
}
